import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { FieldTextInput, Form } from '../index';
import css from './OrderBreakdown.module.css';
import CollapsibleSection from '../CollapsibleSection/CollapsibleSection';
import DiscountOutlinedIcon from '@mui/icons-material/DiscountOutlined';
import { soulWiseTheme } from '../../mui-theme';
import { SecondaryButton } from '../mui/Button';
import { FormattedMessage, useIntl } from '../../util/reactIntl';

const CustomerDiscountForm = props => {
  const { validateDiscountError, onSubmit, inProgress } = props;
  const intl = useIntl();

  const handleSubmit = values => {
    if (values.userTryOnDiscountCode) {
      onSubmit(values.userTryOnDiscountCode);
    }
  };

  return (
    <CollapsibleSection
      header={
        <div className={css.headerContainer}>
          <DiscountOutlinedIcon
            sx={{ width: 16, height: 16, color: soulWiseTheme.palette.white80 }}
          />
          <span className={css.headerText}>
            <FormattedMessage id="CustomerDiscountForm.header" />
          </span>
        </div>
      }
    >
      <FinalForm
        onSubmit={handleSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <div className={css.discountContainer}>
              <FieldTextInput
                id="userTryOnDiscountCode"
                name="userTryOnDiscountCode"
                type="text"
                placeholder={intl.formatMessage({ id: 'CustomerDiscountForm.placeholder' })}
                className={css.input}
                disabled={inProgress}
                // This will ensure the input is always uppercase
                parse={v => (v ? v.toUpperCase() : '')}
                customErrorText={
                  validateDiscountError
                    ? intl.formatMessage({ id: 'CustomerDiscountForm.invalid' })
                    : ''
                }
              />
              <SecondaryButton
                type="submit"
                disabled={inProgress}
                sx={{ marginTop: { md: '8px' } }}
              >
                <FormattedMessage id="CustomerDiscountForm.apply" />
              </SecondaryButton>
            </div>
          </Form>
        )}
      />
    </CollapsibleSection>
  );
};

export default CustomerDiscountForm;
